import { debugLog } from './debugLog.js';
import { logError, logEvent } from './logging.js';

/**
 * See Cohesion docs here:
 * https://redventures.atlassian.net/wiki/spaces/COHSN/pages/1427145833/Client+API+-+Monarch
 *
 * @param method - the Monarch method being called (rule vs ruleset)
 * @param id - the rule or ruleset id
 * @param payload -  any additional information to include in the request (ex parsed url params)
 * @param params - request params config
 * @param callback - function to call upon request complete
 * @returns monarch's raw response
 */
const requestMonarch = async _ref => {
  let {
    method,
    id,
    payload = {
      _Monarch: {
        returnEvaluatedSubjects: true
      }
    },
    params = {
      context: ''
    },
    callback = c => c
  } = _ref;
  debugLog('requestMonarch called');
  if (window.monarch) {
    debugLog('requestMonarch - sending out monarch request');
    const response = await window.monarch(method, id, payload, params, (err, result) => {
      if (err) {
        const errString = JSON.stringify(err);
        console.error('monarch:error', err);
        logError(`monarch:error ${errString}`);
        logEvent('monarch:error', {
          error: errString
        });
        debugLog('requestMonarch - monarch:error', err);
      } else {
        debugLog('requestMonarch - monarch:evaluated', result);
        logEvent('monarch:evaluated');
      }
      return callback(err, result);
    });
    return response;
  }
};

export { requestMonarch };
